<script setup>
import { ref, onMounted } from 'vue'

const headImgUrl = ref('https://p3.ssl.qhimg.com/t0127aaf045842c0d2c.png') //头部背景
// const conferenceImgUrl = ref("https://p2.ssl.qhimg.com/t01bd3aebda1e0536f1.png")//大会
const conventionImgUrl = ref('https://p1.ssl.qhimg.com/t0118119869f7437f91.png') //大会背景
const registrationImgUrl = ref('https://p3.ssl.qhimg.com/t01a9d785b76c73ee7c.png') //报名时间
const topicImgUrl = ref('https://p3.ssl.qhimg.com/t0192cd20a1a7e8bbf4.png') //议题征集
const encourageImgUrl = ref('https://p2.ssl.qhimg.com/t01bc2c53c11753b367.png') //鼓励
const stageImgUrl = ref('https://p5.ssl.qhimg.com/t01e933498f2a8c1141.png') //舞台
const surpriseImgUrl = ref('https://p0.ssl.qhimg.com/t019c79439d2c4582b7.jpg') //惊喜

// const downloadBtnImgUrl = ref("")//下载按钮
const downloadImgUrl = ref('https://p4.ssl.qhimg.com/t01ab521147353e6f61.png') //下载speaker议题

const downloadImgUrl2 = ref('https://p4.ssl.qhimg.com/t0163a6c88928a6308e.png') //下载listen议题

// const recruitImgUrl = ref("https://p3.ssl.qhimg.com/t0176722457ee5a602b.png")//议题招募
// const sandboxImgUrl = ref("https://p2.ssl.qhimg.com/t016e8ec3fade2bb748.png")//沙盒大赛

const speakerUrl = ref('https://cdn.isc.360.com/iscvideo-bucket/ISC_2023_call_for_Speaker.docx.zip')
const listenerUrl = ref(
  'https://cdn.isc.360.com/iscvideo-bucket/ISC_2023_call_for_Listener.docx.zip'
)
// const conferenceVideoUrl = ref("http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4")

onMounted(() => {
  let offH = window.innerHeight * 0.5
  // console.log("offH: ",offH)
  // let middleContent = document.querySelector(".middle-content");
  let bgMask = document.querySelector('.bg-mask')

  window.addEventListener('scroll', () => {
    // console.log(window.scrollY)

    let scrollY = window.scrollY
    // let opacity = scrollY/offH
    // let whiteColor =  "rgba(255,255,255," + opacity + ")";
    // let whiteAttr =  "background-color:" + whiteColor + ";"
    // middleContent.setAttribute("style", whiteAttr);

    let blackOpacity = scrollY / offH
    blackOpacity = blackOpacity > 1 ? 1 : blackOpacity
    blackOpacity = 0.3 * blackOpacity
    let blackColor = 'rgba(0,0,0,' + blackOpacity + ')'
    let blackAttr = 'background-color:' + blackColor + ';'
    bgMask.setAttribute('style', blackAttr)
  })
})
</script>

<template>
  <div class="background">
    <img class="bg-head" :src="headImgUrl" />
    <div class="bg-bottom"></div>
  </div>
  <div class="bg-mask"></div>

  <div class="content">
    <!-- <video class="conference"  controls autoplay>
            <source :src="conferenceVideoUrl">
        </video> -->
    <div class="middle-content">
      <img class="bigConvention" :src="conventionImgUrl" />
      <img class="topic" :src="topicImgUrl" />
      <img class="registration" :src="registrationImgUrl" />
      <img class="stage" :src="stageImgUrl" />

      <a class="downloadBtn" :href="speakerUrl">下载报名文档</a>
      <img class="downloadTopic" :src="downloadImgUrl" />

      <img class="encourage" :src="encourageImgUrl" />

      <a class="downloadBtn2" :href="listenerUrl">下载报名文档</a>
      <img class="downloadTopic2" :src="downloadImgUrl2" />

      <img class="surprise" :src="surpriseImgUrl" />
    </div>
  </div>
  <!-- <div class="right-content">
        <img class="recruit" :src="recruitImgUrl" />
        <img class="sandbox" :src="sandboxImgUrl" />
    </div> -->
</template>

<style lang="scss" scoped>
.background {
  width: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
}

.bg-head {
  width: 100%;
}

.bg-bottom {
  width: 100%;
  height: 30px;
  background: #1833ff;
}

.bg-mask {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}

.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 45%;
  position: relative;
  overflow-y: scroll;
}

.conference {
  width: 1000px;
  height: 563px;
  object-fit: contain;
}

.middle-content {
  margin-top: 60px;
  width: 1200px;
  text-align: center;
  padding-top: 80px;
  padding-bottom: 100px;
  background-color: rgba(255, 255, 255, 1);
}

.bigConvention {
  width: 926px;
  height: 669px;
  object-fit: contain;
}

.topic {
  margin-top: 150px;
  width: 931px;
  height: 930px;
  object-fit: contain;
}

.registration {
  margin-top: 50px;
  width: 1200px;
  height: 385px;
  object-fit: contain;
}

.stage {
  margin-top: 130px;
  width: 928px;
  height: 773px;
  object-fit: contain;
}

.downloadBtn {
  margin-top: 90px;
  display: inline-block;
  width: 600px;
  height: 100px;
  background: linear-gradient(0deg, #1833ff, #2e5fff);
  box-shadow: 0px 6px 20px 0px rgba(24, 127, 255, 0.5);
  border-radius: 50px;
  font-size: 36px;
  font-family: OPPOSans;
  font-weight: 500;
  color: #ffffff;
  line-height: 100px;
  text-align: center;
}

.downloadTopic {
  margin-top: 50px;
  width: 716px;
  height: 34px;
  object-fit: contain;
}

.encourage {
  margin-top: 140px;
  width: 930px;
  height: 540px;
  object-fit: contain;
}

.downloadBtn2 {
  margin-top: 100px;
  display: inline-block;
  width: 600px;
  height: 100px;
  background: linear-gradient(0deg, #1833ff, #2e5fff);
  box-shadow: 0px 6px 20px 0px rgba(24, 127, 255, 0.5);
  border-radius: 50px;
  font-size: 36px;
  font-family: OPPOSans;
  font-weight: 500;
  color: #ffffff;
  line-height: 100px;
  text-align: center;
}

.downloadTopic2 {
  margin-top: 50px;
  width: 716px;
  height: 34px;
  object-fit: contain;
}

.surprise {
  margin-top: 145px;
  width: 927px;
  height: 305px;
  object-fit: contain;
}

.right-content {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 200px;
  right: 200px;
}

.recruit {
  width: 160px;
  height: 160px;
  object-fit: contain;
}

.sandbox {
  margin-top: 0px;
  width: 160px;
  height: 160px;
  object-fit: contain;
}
</style>
